// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ticket details layout */
.ns-support-details-page {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 7.5rem);
  max-height: calc(100vh - 7.5rem);
}

.ns-support-tabs {
  display: flex;
  align-items: flex-end;
  gap: 0.25rem;
  padding: 0 0.15rem;
  margin-bottom: 0.75rem;
  overflow-x: auto;
  flex-shrink: 0;
  border-bottom: 1px solid #e2e8f0;
  min-height: 48px;
}

.ns-support-tabs__tab {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 120px;
  max-width: 220px;
  padding: 0.4rem 0.65rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #475569;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.ns-support-tabs__tab:hover {
  background: #e8ecf4;
  color: #4346ce;
}

.ns-support-tabs__tab--active {
  background: #fff;
  color: #4346ce;
  font-weight: 600;
  border-color: #e2e8f0;
  box-shadow: 0 -2px 0 #4346ce inset;
}

.ns-support-tabs__label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.1rem;
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
  line-height: 1.2;
  text-align: left;
}

.ns-support-tabs__subject {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ns-support-tabs__ref {
  max-width: 100%;
  font-size: 0.6875rem;
  font-weight: 500;
  color: #94a3b8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ns-support-tabs__tab--active .ns-support-tabs__ref {
  color: #64748b;
}

.ns-support-tabs__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  flex-shrink: 0;
}

.ns-support-tabs__close:hover {
  background: rgba(15, 23, 42, 0.08);
  color: #334155;
}

.ns-support-details-grid {
  display: grid;
  grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);
  gap: 1rem;
  flex: 1 1;
  min-height: 0;
}

@media (max-width: 991px) {
  .ns-support-details-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }
  .ns-support-details-rail {
    display: none;
  }
}

.ns-support-details-left {
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.ns-support-details-left .card {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

.ns-support-details-left .card-body {
  flex: 1 1;
  overflow-y: auto;
  max-height: none !important;
}

.ns-support-details-center {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: visible;
  position: relative;
  z-index: 1;
}

.ns-support-thread-panel {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.ns-support-thread-panel__header {
  flex-shrink: 0;
  padding: 0.65rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
  border-bottom: 1px solid #eef2f7;
  background: #fafbfc;
  border-radius: 12px 12px 0 0;
}

.ns-support-messages-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 1rem 1rem 0.5rem;
  background: #eceff4;
}

.ns-support-reply-resize-handle {
  flex-shrink: 0;
  height: 8px;
  cursor: ns-resize;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  background: #fff;
  border-top: 1px solid #e2e8f0;
}

.ns-support-reply-resize-handle::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background: #cbd5e1;
  transition: background 0.15s ease;
}

.ns-support-reply-resize-handle:hover::before,
.ns-support-reply-resize-handle:active::before {
  background: #94a3b8;
}

body.ns-support-reply-resizing {
  cursor: ns-resize !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}

body.ns-support-reply-resizing * {
  cursor: ns-resize !important;
}

.ns-support-msg {
  display: flex;
  gap: 0.65rem;
  margin-bottom: 1rem;
  align-items: flex-start;
}

.ns-support-msg--pending {
  opacity: 0.88;
}

.ns-support-msg__avatar {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #4346ce;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
}

.ns-support-msg__avatar--customer {
  background: #0ea5e9;
}

.ns-support-msg__avatar--email {
  background: #64748b;
}

.ns-support-msg__body {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 76%;
}

.ns-support-msg__bubble {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.ns-support-msg__bubble--pending {
  background: #fffbeb;
  border-style: dashed;
  border-color: #fcd34d;
}

.ns-support-msg__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.75rem;
  margin-bottom: 0.35rem;
}

.ns-support-msg__name {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #1e293b;
}

.ns-support-msg__time {
  font-size: 0.6875rem;
  color: #94a3b8;
}

.ns-support-msg__text {
  font-size: 0.875rem;
  line-height: 1.5;
  color: #334155;
}

/* Plain-text fallback (rare): no pre-wrap — line breaks come from display HTML conversion. */
.ns-support-msg__text--plain {
  overflow-wrap: anywhere;
}

/* Chat-style: team-member (outgoing) messages hug the right with a tinted bubble;
   customer/email (incoming) stay on the left with a white bubble. */
.ns-support-msg--out {
  flex-direction: row-reverse;
}
.ns-support-msg--out .ns-support-msg__meta {
  justify-content: flex-end;
}
.ns-support-msg--out .ns-support-msg__bubble:not(.ns-support-msg__bubble--pending) {
  background: #dcd8f8;
  border-color: #c6c1f0;
}

/* Consecutive messages from the same sender: hide the repeated name + avatar and
   tighten spacing (WhatsApp-style grouping). */
.ns-support-msg--grouped {
  margin-top: -0.55rem;
}
.ns-support-msg--grouped .ns-support-msg__avatar {
  visibility: hidden;
}
.ns-support-msg--grouped .ns-support-msg__name {
  display: none;
}

.ns-support-details-rail {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
  margin-left: auto;
  align-self: center;
  flex-shrink: 0;
  padding-bottom: 0.25rem;
}

.ns-support-rail-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  color: #fff;
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.ns-support-rail-btn:hover {
  transform: scale(1.05);
  border-color: rgba(67, 70, 206, 0.4);
}

.ns-support-rail-btn--active {
  border-color: #4346ce;
  box-shadow: 0 0 0 3px rgba(67, 70, 206, 0.2);
}

.ns-support-profile-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: min(360px, 92vw);
  height: 100vh;
  background: #fff;
  border-left: 1px solid #e2e8f0;
  box-shadow: -8px 0 32px rgba(15, 23, 42, 0.12);
  z-index: 1050;
  display: flex;
  flex-direction: column;
}

.ns-support-profile-drawer__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  z-index: 1045;
}

.ns-support-profile-drawer__head {
  padding: 1rem;
  border-bottom: 1px solid #eef2f7;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.ns-support-profile-drawer__list {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.75rem 1rem;
}

.ns-support-profile-drawer__item {
  padding: 0.65rem 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.8125rem;
}

.ns-support-reply-format-wrap {
  position: relative;
}

.ns-support-reply-format-panel {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  z-index: 30;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.15rem;
  width: max-content;
  max-width: min(100vw - 2rem, 420px);
  padding: 0.35rem 0.5rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  overflow-x: auto;
}

.ns-support-reply-format-panel .ns-support-reply-format__btn,
.ns-support-reply-format-panel .ns-support-reply-format__sep {
  flex-shrink: 0;
}

.ns-support-reply-format__sep {
  width: 1px;
  height: 20px;
  margin: 0 0.2rem;
  background: #e2e8f0;
}

.ns-support-reply-header {
  margin-bottom: 0.5rem;
}

.ns-support-reply-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eef2f7;
}

.ns-support-reply-tools {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  margin-top: 0;
  padding-top: 0;
  border-top: none;
  position: relative;
  overflow: visible;
  flex-shrink: 0;
}

.ns-support-reply-tools__text {
  font-size: 0.875rem;
  font-weight: 700;
  font-family: Georgia, "Times New Roman", serif;
  letter-spacing: 0.02em;
}

.ns-support-reply-tools__text--active {
  background: #e0e7ff;
  color: #4346ce;
}

.ns-support-reply-format__btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ns-support-reply-format__btn:hover:not(:disabled) {
  background: #f1f5f9;
  color: #4346ce;
}

.ns-support-reply-format__btn--active,
.ns-support-reply-format__btn--active:hover:not(:disabled) {
  background: #e0e7ff;
  color: #4346ce;
}

.ns-support-reply-format__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.ns-support-emoji-wrap {
  position: relative;
}

.ns-support-emoji-picker-popover {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  z-index: 30;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  border: 1px solid #e2e8f0;
}

/* --- Help me write (AI reply assist) --- */
.ns-support-ai-wrap {
  position: relative;
  margin-right: 0.15rem;
}

.ns-support-ai-btn {
  width: auto;
  gap: 0.35rem;
  padding: 0 0.6rem;
  color: #4346ce;
  background: #eef0ff;
  font-size: 0.8rem;
  font-weight: 600;
}

.ns-support-ai-btn:hover:not(:disabled) {
  background: #e0e7ff;
  color: #4346ce;
}

.ns-support-ai-btn--active,
.ns-support-ai-btn--active:hover:not(:disabled) {
  background: #4346ce;
  color: #fff;
}

.ns-support-ai-btn__label {
  white-space: nowrap;
}

.ns-support-ai-panel {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  z-index: 31;
  width: min(100vw - 2rem, 380px);
  padding: 0.6rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
}

.ns-support-ai-panel__head {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #334155;
  font-size: 0.82rem;
  font-weight: 600;
  margin-bottom: 0.45rem;
}

.ns-support-ai-panel__head > span {
  flex: 1 1;
}

.ns-support-ai-panel__close {
  border: none;
  background: transparent;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 0;
}

.ns-support-ai-panel__close:hover {
  color: #475569;
}

.ns-support-ai-panel__input {
  width: 100%;
  resize: vertical;
  min-height: 60px;
  padding: 0.5rem 0.6rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.85rem;
  line-height: 1.45;
  color: #1e293b;
  outline: none;
}

.ns-support-ai-panel__input:focus {
  border-color: #4346ce;
  box-shadow: 0 0 0 3px rgba(67, 70, 206, 0.12);
}

.ns-support-ai-panel__input:disabled {
  background: #f8fafc;
  cursor: not-allowed;
}

.ns-support-ai-panel__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  margin-top: 0.5rem;
}

.ns-support-ai-panel__hint {
  font-size: 0.7rem;
  color: #94a3b8;
  line-height: 1.3;
}

.ns-support-ai-panel__generate {
  flex-shrink: 0;
  padding: 0.4rem 0.9rem;
  font-size: 0.82rem;
}

.ns-support-ai-panel__generate:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Support ticket — reply composer (sticky footer) */
.ns-support-reply-wrap {
  flex-shrink: 0;
  padding: 0.65rem 1rem 0.85rem;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  overflow: visible;
  border-radius: 0 0 12px 12px;
}

.ns-support-reply-to {
  margin: 0;
  font-size: 0.8125rem;
  color: #64748b;
  min-width: 8rem;
}

.ns-support-reply-editor {
  margin-bottom: 0;
}

.ns-support-reply-editor .quill {
  display: flex;
  flex-direction: column;
}

.ns-support-reply-editor .ql-toolbar {
  display: none;
}

.ns-support-reply-editor .ql-container {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: #0f172a;
  background: #fff;
  font-family: inherit;
  height: var(--ns-reply-editor-height, 120px);
}

.ns-support-reply-editor .ql-container.ql-focused {
  border-color: rgba(67, 70, 206, 0.45);
  box-shadow: 0 0 0 3px rgba(67, 70, 206, 0.1);
}

.ns-support-reply-editor .ql-editor {
  height: 100%;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
  padding: 0.65rem 0.75rem;
}

.ns-support-reply-editor .ql-editor.ql-blank::before {
  color: #94a3b8;
  font-style: normal;
}

.ns-support-reply-editor--disabled .ql-editor {
  background: #f8fafc;
  color: #64748b;
}

.ns-support-msg__text--html {
  /* Email signatures often use align="left" tables; contain floats inside this block. */
  display: flow-root;
  line-height: 2;
  overflow-wrap: anywhere;
}

.ns-support-msg__text--html table {
  float: none !important;
  max-width: 100%;
}

.ns-support-msg__attachments {
  clear: both;
  width: 100%;
}

.ns-support-msg__text--html p {
  margin: 0 0 0.35em;
  padding: 0;
}

.ns-support-msg__text--html p:last-child {
  margin-bottom: 0;
}

.ns-support-msg__text--html img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0.5rem 0;
  border-radius: 4px;
}

.ns-support-msg__text--html ul,
.ns-support-msg__text--html ol {
  margin: 0.25rem 0 0.35rem 1.1rem;
  padding: 0;
}

.ns-support-msg__text--html blockquote {
  margin: 0.25rem 0;
  padding-left: 0.65rem;
  border-left: 3px solid #cbd5e1;
  color: #475569;
}

.ns-support-msg__text--html pre,
.ns-support-msg__text--html code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.85em;
  background: #f1f5f9;
  border-radius: 4px;
}

.ns-support-msg__text--html pre {
  padding: 0.35rem 0.5rem;
  overflow-x: auto;
}

.ns-support-reply-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0;
  margin-left: auto;
  flex-shrink: 0;
}

.ns-support-reply-send.btn_theme_primary {
  gap: 0.4rem;
  padding: 0.45rem 1rem !important;
  border-radius: 8px !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  background-color: #4346ce !important;
  border-color: #3a3db3 !important;
  color: #fff !important;
  box-shadow: rgba(5, 27, 44, 0.16) 0 1px 1px, rgba(255, 255, 255, 0.05) 0 1px 0 inset;
}

.ns-support-reply-send.btn_theme_primary:hover:not(:disabled) {
  background-color: #3a3db3 !important;
  border-color: #3235a0 !important;
}


.ns-support-reply-composer__attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0 0 0.5rem;
}

.ns-support-reply-composer__chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 220px;
  padding: 0.35rem 0.45rem 0.35rem 0.35rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.75rem;
  color: #334155;
}

.ns-support-reply-composer__chip-thumb {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  overflow: hidden;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ns-support-reply-composer__chip-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ns-support-reply-composer__chip-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.ns-support-reply-composer__chip-remove {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.ns-support-reply-composer__chip-remove:hover:not(:disabled) {
  background: #fee2e2;
  color: #dc2626;
}

.ns-support-reply-composer__chip-remove:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ns-support-requester-ticket {
  position: relative;
  border-bottom: 1px solid #f1f5f9;
}

.ns-support-requester-ticket--current .ns-support-requester-ticket__row {
  background: rgba(67, 70, 206, 0.06);
}

.ns-support-requester-ticket__row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
  padding: 0.65rem 0;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 0.8125rem;
  cursor: pointer;
}

.ns-support-requester-ticket__row:hover {
  color: #4346ce;
}

.ns-support-requester-ticket__status {
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
}

.ns-support-requester-ticket__subject {
  min-width: 0;
  font-weight: 500;
  color: #0f172a;
}

.ns-support-requester-ticket__date {
  font-size: 0.6875rem;
  white-space: nowrap;
}

.ns-support-requester-ticket__preview {
  padding: 0.75rem 0.85rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18);
  pointer-events: none;
  color: #0f172a;
}

.ns-support-requester-ticket__preview--portal {
  position: fixed;
  z-index: 1065;
  max-height: min(280px, 50vh);
  overflow-y: auto;
}

/* Safari: overflow scrollbars can paint above SweetAlert — lock page scrolls while open. */
body.swal2-shown .ns-support-details-left .card-body,
body.swal2-shown .ns-support-messages-scroll,
body.swal2-shown .ns-support-requester-ticket__preview--portal {
  overflow: hidden !important;
}

.ns-support-requester-ticket__preview-ref {
  font-weight: 700;
  font-size: 0.8125rem;
  margin-bottom: 0.25rem;
  color: #4346ce;
}

.ns-support-requester-ticket__preview-subject {
  font-weight: 600;
  font-size: 0.8125rem;
  line-height: 1.35;
  margin-bottom: 0.5rem;
  color: #0f172a;
}

.ns-support-requester-ticket__preview-meta {
  display: grid;
  gap: 0.25rem;
  margin: 0 0 0.5rem;
  font-size: 0.75rem;
}

.ns-support-requester-ticket__preview-meta > div {
  display: grid;
  grid-template-columns: 4.5rem 1fr;
  gap: 0.35rem;
  align-items: baseline;
}

.ns-support-requester-ticket__preview-meta dt {
  margin: 0;
  font-weight: 600;
  color: #64748b;
}

.ns-support-requester-ticket__preview-meta dd {
  margin: 0;
  color: #334155;
}

.ns-support-requester-ticket__preview-snippet {
  margin: 0;
  padding-top: 0.45rem;
  border-top: 1px solid #f1f5f9;
  font-size: 0.75rem;
  line-height: 1.45;
  color: #475569;
}
`, "",{"version":3,"sources":["webpack://./src/components/app-support/AppSupportTicketDetails.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6FAA6F;AAC7F;EACE,uBAAuB;AACzB;;AAEA;oEACoE;AACpE;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;+CAC+C;AAC/C;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,8CAA8C;EAC9C,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sFAAsF;EACtF,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;EAEE,6EAA6E;EAC7E,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,2FAA2F;AAC3F;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["/* Ticket details layout */\n.ns-support-details-page {\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 7.5rem);\n  max-height: calc(100vh - 7.5rem);\n}\n\n.ns-support-tabs {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.25rem;\n  padding: 0 0.15rem;\n  margin-bottom: 0.75rem;\n  overflow-x: auto;\n  flex-shrink: 0;\n  border-bottom: 1px solid #e2e8f0;\n  min-height: 48px;\n}\n\n.ns-support-tabs__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 120px;\n  max-width: 220px;\n  padding: 0.4rem 0.65rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #475569;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-bottom: none;\n  border-radius: 8px 8px 0 0;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.ns-support-tabs__tab:hover {\n  background: #e8ecf4;\n  color: #4346ce;\n}\n\n.ns-support-tabs__tab--active {\n  background: #fff;\n  color: #4346ce;\n  font-weight: 600;\n  border-color: #e2e8f0;\n  box-shadow: 0 -2px 0 #4346ce inset;\n}\n\n.ns-support-tabs__label {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.1rem;\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  line-height: 1.2;\n  text-align: left;\n}\n\n.ns-support-tabs__subject {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ns-support-tabs__ref {\n  max-width: 100%;\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: #94a3b8;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ns-support-tabs__tab--active .ns-support-tabs__ref {\n  color: #64748b;\n}\n\n.ns-support-tabs__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.ns-support-tabs__close:hover {\n  background: rgba(15, 23, 42, 0.08);\n  color: #334155;\n}\n\n.ns-support-details-grid {\n  display: grid;\n  grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);\n  gap: 1rem;\n  flex: 1;\n  min-height: 0;\n}\n\n@media (max-width: 991px) {\n  .ns-support-details-grid {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto 1fr;\n  }\n  .ns-support-details-rail {\n    display: none;\n  }\n}\n\n.ns-support-details-left {\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.ns-support-details-left .card {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n}\n\n.ns-support-details-left .card-body {\n  flex: 1;\n  overflow-y: auto;\n  max-height: none !important;\n}\n\n.ns-support-details-center {\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n  position: relative;\n  z-index: 1;\n}\n\n.ns-support-thread-panel {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.ns-support-thread-panel__header {\n  flex-shrink: 0;\n  padding: 0.65rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #334155;\n  border-bottom: 1px solid #eef2f7;\n  background: #fafbfc;\n  border-radius: 12px 12px 0 0;\n}\n\n.ns-support-messages-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 1rem 1rem 0.5rem;\n  background: #eceff4;\n}\n\n.ns-support-reply-resize-handle {\n  flex-shrink: 0;\n  height: 8px;\n  cursor: ns-resize;\n  touch-action: none;\n  user-select: none;\n  position: relative;\n  background: #fff;\n  border-top: 1px solid #e2e8f0;\n}\n\n.ns-support-reply-resize-handle::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 40px;\n  height: 4px;\n  border-radius: 2px;\n  background: #cbd5e1;\n  transition: background 0.15s ease;\n}\n\n.ns-support-reply-resize-handle:hover::before,\n.ns-support-reply-resize-handle:active::before {\n  background: #94a3b8;\n}\n\nbody.ns-support-reply-resizing {\n  cursor: ns-resize !important;\n  user-select: none !important;\n}\n\nbody.ns-support-reply-resizing * {\n  cursor: ns-resize !important;\n}\n\n.ns-support-msg {\n  display: flex;\n  gap: 0.65rem;\n  margin-bottom: 1rem;\n  align-items: flex-start;\n}\n\n.ns-support-msg--pending {\n  opacity: 0.88;\n}\n\n.ns-support-msg__avatar {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #4346ce;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none;\n}\n\n.ns-support-msg__avatar--customer {\n  background: #0ea5e9;\n}\n\n.ns-support-msg__avatar--email {\n  background: #64748b;\n}\n\n.ns-support-msg__body {\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 76%;\n}\n\n.ns-support-msg__bubble {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.65rem 0.85rem;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.ns-support-msg__bubble--pending {\n  background: #fffbeb;\n  border-style: dashed;\n  border-color: #fcd34d;\n}\n\n.ns-support-msg__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.35rem 0.75rem;\n  margin-bottom: 0.35rem;\n}\n\n.ns-support-msg__name {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.ns-support-msg__time {\n  font-size: 0.6875rem;\n  color: #94a3b8;\n}\n\n.ns-support-msg__text {\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #334155;\n}\n\n/* Plain-text fallback (rare): no pre-wrap — line breaks come from display HTML conversion. */\n.ns-support-msg__text--plain {\n  overflow-wrap: anywhere;\n}\n\n/* Chat-style: team-member (outgoing) messages hug the right with a tinted bubble;\n   customer/email (incoming) stay on the left with a white bubble. */\n.ns-support-msg--out {\n  flex-direction: row-reverse;\n}\n.ns-support-msg--out .ns-support-msg__meta {\n  justify-content: flex-end;\n}\n.ns-support-msg--out .ns-support-msg__bubble:not(.ns-support-msg__bubble--pending) {\n  background: #dcd8f8;\n  border-color: #c6c1f0;\n}\n\n/* Consecutive messages from the same sender: hide the repeated name + avatar and\n   tighten spacing (WhatsApp-style grouping). */\n.ns-support-msg--grouped {\n  margin-top: -0.55rem;\n}\n.ns-support-msg--grouped .ns-support-msg__avatar {\n  visibility: hidden;\n}\n.ns-support-msg--grouped .ns-support-msg__name {\n  display: none;\n}\n\n.ns-support-details-rail {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.4rem;\n  margin-left: auto;\n  align-self: center;\n  flex-shrink: 0;\n  padding-bottom: 0.25rem;\n}\n\n.ns-support-rail-btn {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 2px solid transparent;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #fff;\n  transition: border-color 0.15s ease, transform 0.15s ease;\n}\n\n.ns-support-rail-btn:hover {\n  transform: scale(1.05);\n  border-color: rgba(67, 70, 206, 0.4);\n}\n\n.ns-support-rail-btn--active {\n  border-color: #4346ce;\n  box-shadow: 0 0 0 3px rgba(67, 70, 206, 0.2);\n}\n\n.ns-support-profile-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: min(360px, 92vw);\n  height: 100vh;\n  background: #fff;\n  border-left: 1px solid #e2e8f0;\n  box-shadow: -8px 0 32px rgba(15, 23, 42, 0.12);\n  z-index: 1050;\n  display: flex;\n  flex-direction: column;\n}\n\n.ns-support-profile-drawer__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.35);\n  z-index: 1045;\n}\n\n.ns-support-profile-drawer__head {\n  padding: 1rem;\n  border-bottom: 1px solid #eef2f7;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.ns-support-profile-drawer__list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.75rem 1rem;\n}\n\n.ns-support-profile-drawer__item {\n  padding: 0.65rem 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 0.8125rem;\n}\n\n.ns-support-reply-format-wrap {\n  position: relative;\n}\n\n.ns-support-reply-format-panel {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 0;\n  z-index: 30;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0.15rem;\n  width: max-content;\n  max-width: min(100vw - 2rem, 420px);\n  padding: 0.35rem 0.5rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  overflow-x: auto;\n}\n\n.ns-support-reply-format-panel .ns-support-reply-format__btn,\n.ns-support-reply-format-panel .ns-support-reply-format__sep {\n  flex-shrink: 0;\n}\n\n.ns-support-reply-format__sep {\n  width: 1px;\n  height: 20px;\n  margin: 0 0.2rem;\n  background: #e2e8f0;\n}\n\n.ns-support-reply-header {\n  margin-bottom: 0.5rem;\n}\n\n.ns-support-reply-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid #eef2f7;\n}\n\n.ns-support-reply-tools {\n  display: flex;\n  align-items: center;\n  gap: 0.15rem;\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n  position: relative;\n  overflow: visible;\n  flex-shrink: 0;\n}\n\n.ns-support-reply-tools__text {\n  font-size: 0.875rem;\n  font-weight: 700;\n  font-family: Georgia, \"Times New Roman\", serif;\n  letter-spacing: 0.02em;\n}\n\n.ns-support-reply-tools__text--active {\n  background: #e0e7ff;\n  color: #4346ce;\n}\n\n.ns-support-reply-format__btn {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.ns-support-reply-format__btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #4346ce;\n}\n\n.ns-support-reply-format__btn--active,\n.ns-support-reply-format__btn--active:hover:not(:disabled) {\n  background: #e0e7ff;\n  color: #4346ce;\n}\n\n.ns-support-reply-format__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.ns-support-emoji-wrap {\n  position: relative;\n}\n\n.ns-support-emoji-picker-popover {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 0;\n  z-index: 30;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  border: 1px solid #e2e8f0;\n}\n\n/* --- Help me write (AI reply assist) --- */\n.ns-support-ai-wrap {\n  position: relative;\n  margin-right: 0.15rem;\n}\n\n.ns-support-ai-btn {\n  width: auto;\n  gap: 0.35rem;\n  padding: 0 0.6rem;\n  color: #4346ce;\n  background: #eef0ff;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.ns-support-ai-btn:hover:not(:disabled) {\n  background: #e0e7ff;\n  color: #4346ce;\n}\n\n.ns-support-ai-btn--active,\n.ns-support-ai-btn--active:hover:not(:disabled) {\n  background: #4346ce;\n  color: #fff;\n}\n\n.ns-support-ai-btn__label {\n  white-space: nowrap;\n}\n\n.ns-support-ai-panel {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 0;\n  z-index: 31;\n  width: min(100vw - 2rem, 380px);\n  padding: 0.6rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);\n}\n\n.ns-support-ai-panel__head {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: #334155;\n  font-size: 0.82rem;\n  font-weight: 600;\n  margin-bottom: 0.45rem;\n}\n\n.ns-support-ai-panel__head > span {\n  flex: 1;\n}\n\n.ns-support-ai-panel__close {\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0;\n}\n\n.ns-support-ai-panel__close:hover {\n  color: #475569;\n}\n\n.ns-support-ai-panel__input {\n  width: 100%;\n  resize: vertical;\n  min-height: 60px;\n  padding: 0.5rem 0.6rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  color: #1e293b;\n  outline: none;\n}\n\n.ns-support-ai-panel__input:focus {\n  border-color: #4346ce;\n  box-shadow: 0 0 0 3px rgba(67, 70, 206, 0.12);\n}\n\n.ns-support-ai-panel__input:disabled {\n  background: #f8fafc;\n  cursor: not-allowed;\n}\n\n.ns-support-ai-panel__foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.6rem;\n  margin-top: 0.5rem;\n}\n\n.ns-support-ai-panel__hint {\n  font-size: 0.7rem;\n  color: #94a3b8;\n  line-height: 1.3;\n}\n\n.ns-support-ai-panel__generate {\n  flex-shrink: 0;\n  padding: 0.4rem 0.9rem;\n  font-size: 0.82rem;\n}\n\n.ns-support-ai-panel__generate:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Support ticket — reply composer (sticky footer) */\n.ns-support-reply-wrap {\n  flex-shrink: 0;\n  padding: 0.65rem 1rem 0.85rem;\n  background: #fff;\n  border-top: 1px solid #e2e8f0;\n  overflow: visible;\n  border-radius: 0 0 12px 12px;\n}\n\n.ns-support-reply-to {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: #64748b;\n  min-width: 8rem;\n}\n\n.ns-support-reply-editor {\n  margin-bottom: 0;\n}\n\n.ns-support-reply-editor .quill {\n  display: flex;\n  flex-direction: column;\n}\n\n.ns-support-reply-editor .ql-toolbar {\n  display: none;\n}\n\n.ns-support-reply-editor .ql-container {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: #0f172a;\n  background: #fff;\n  font-family: inherit;\n  height: var(--ns-reply-editor-height, 120px);\n}\n\n.ns-support-reply-editor .ql-container.ql-focused {\n  border-color: rgba(67, 70, 206, 0.45);\n  box-shadow: 0 0 0 3px rgba(67, 70, 206, 0.1);\n}\n\n.ns-support-reply-editor .ql-editor {\n  height: 100%;\n  min-height: 0;\n  max-height: none;\n  overflow-y: auto;\n  padding: 0.65rem 0.75rem;\n}\n\n.ns-support-reply-editor .ql-editor.ql-blank::before {\n  color: #94a3b8;\n  font-style: normal;\n}\n\n.ns-support-reply-editor--disabled .ql-editor {\n  background: #f8fafc;\n  color: #64748b;\n}\n\n.ns-support-msg__text--html {\n  /* Email signatures often use align=\"left\" tables; contain floats inside this block. */\n  display: flow-root;\n  line-height: 2;\n  overflow-wrap: anywhere;\n}\n\n.ns-support-msg__text--html table {\n  float: none !important;\n  max-width: 100%;\n}\n\n.ns-support-msg__attachments {\n  clear: both;\n  width: 100%;\n}\n\n.ns-support-msg__text--html p {\n  margin: 0 0 0.35em;\n  padding: 0;\n}\n\n.ns-support-msg__text--html p:last-child {\n  margin-bottom: 0;\n}\n\n.ns-support-msg__text--html img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 0.5rem 0;\n  border-radius: 4px;\n}\n\n.ns-support-msg__text--html ul,\n.ns-support-msg__text--html ol {\n  margin: 0.25rem 0 0.35rem 1.1rem;\n  padding: 0;\n}\n\n.ns-support-msg__text--html blockquote {\n  margin: 0.25rem 0;\n  padding-left: 0.65rem;\n  border-left: 3px solid #cbd5e1;\n  color: #475569;\n}\n\n.ns-support-msg__text--html pre,\n.ns-support-msg__text--html code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.85em;\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.ns-support-msg__text--html pre {\n  padding: 0.35rem 0.5rem;\n  overflow-x: auto;\n}\n\n.ns-support-reply-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.ns-support-reply-send.btn_theme_primary {\n  gap: 0.4rem;\n  padding: 0.45rem 1rem !important;\n  border-radius: 8px !important;\n  font-size: 0.875rem !important;\n  font-weight: 600 !important;\n  background-color: #4346ce !important;\n  border-color: #3a3db3 !important;\n  color: #fff !important;\n  box-shadow: rgba(5, 27, 44, 0.16) 0 1px 1px, rgba(255, 255, 255, 0.05) 0 1px 0 inset;\n}\n\n.ns-support-reply-send.btn_theme_primary:hover:not(:disabled) {\n  background-color: #3a3db3 !important;\n  border-color: #3235a0 !important;\n}\n\n\n.ns-support-reply-composer__attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0 0 0.5rem;\n}\n\n.ns-support-reply-composer__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  max-width: 220px;\n  padding: 0.35rem 0.45rem 0.35rem 0.35rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.75rem;\n  color: #334155;\n}\n\n.ns-support-reply-composer__chip-thumb {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ns-support-reply-composer__chip-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.ns-support-reply-composer__chip-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.ns-support-reply-composer__chip-remove {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.ns-support-reply-composer__chip-remove:hover:not(:disabled) {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.ns-support-reply-composer__chip-remove:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ns-support-requester-ticket {\n  position: relative;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.ns-support-requester-ticket--current .ns-support-requester-ticket__row {\n  background: rgba(67, 70, 206, 0.06);\n}\n\n.ns-support-requester-ticket__row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 0.5rem;\n  align-items: center;\n  width: 100%;\n  padding: 0.65rem 0;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-size: 0.8125rem;\n  cursor: pointer;\n}\n\n.ns-support-requester-ticket__row:hover {\n  color: #4346ce;\n}\n\n.ns-support-requester-ticket__status {\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.ns-support-requester-ticket__subject {\n  min-width: 0;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.ns-support-requester-ticket__date {\n  font-size: 0.6875rem;\n  white-space: nowrap;\n}\n\n.ns-support-requester-ticket__preview {\n  padding: 0.75rem 0.85rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18);\n  pointer-events: none;\n  color: #0f172a;\n}\n\n.ns-support-requester-ticket__preview--portal {\n  position: fixed;\n  z-index: 1065;\n  max-height: min(280px, 50vh);\n  overflow-y: auto;\n}\n\n/* Safari: overflow scrollbars can paint above SweetAlert — lock page scrolls while open. */\nbody.swal2-shown .ns-support-details-left .card-body,\nbody.swal2-shown .ns-support-messages-scroll,\nbody.swal2-shown .ns-support-requester-ticket__preview--portal {\n  overflow: hidden !important;\n}\n\n.ns-support-requester-ticket__preview-ref {\n  font-weight: 700;\n  font-size: 0.8125rem;\n  margin-bottom: 0.25rem;\n  color: #4346ce;\n}\n\n.ns-support-requester-ticket__preview-subject {\n  font-weight: 600;\n  font-size: 0.8125rem;\n  line-height: 1.35;\n  margin-bottom: 0.5rem;\n  color: #0f172a;\n}\n\n.ns-support-requester-ticket__preview-meta {\n  display: grid;\n  gap: 0.25rem;\n  margin: 0 0 0.5rem;\n  font-size: 0.75rem;\n}\n\n.ns-support-requester-ticket__preview-meta > div {\n  display: grid;\n  grid-template-columns: 4.5rem 1fr;\n  gap: 0.35rem;\n  align-items: baseline;\n}\n\n.ns-support-requester-ticket__preview-meta dt {\n  margin: 0;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.ns-support-requester-ticket__preview-meta dd {\n  margin: 0;\n  color: #334155;\n}\n\n.ns-support-requester-ticket__preview-snippet {\n  margin: 0;\n  padding-top: 0.45rem;\n  border-top: 1px solid #f1f5f9;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: #475569;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
